import { COLORS, DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'

export default {
  blurred: {
    filter: 'blur(4px)'
  },
  displayContainer: {
    width: DOWNTILT_PREVIEW_DIMENSIONS.width + 20,
    height: DOWNTILT_PREVIEW_DIMENSIONS.height + 20,
    position: 'relative',
    margin: '2rem auto'
  },
  distanceDisplay: {
    position: 'absolute',
    bottom: 0,
    right: -29,
    lineHeight: '1.8rem',
    borderLeft: `1px solid ${COLORS.quaternary}`,
    paddingLeft: '.3rem',
    width: 30,
    height: 20
  },
  inputWrapper: {
    position: 'relative',
    padding: '0 !important'
  },
  overflowContainer: {
    position: 'absolute',
    height: '100%',
    width: '110%',
    left: 0,
    bottom: 0,
    overflow: 'hidden'
  },
  inputContainer: {
    display: 'flex'
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/style.js